interface ISpanProps {
    /**
     * An arbitrary ID to pass to the {@link operation} to identify which element was clicked.
     */
    id?: string;

    /**
     * The HTML ID to set on the span element.
     */
    spanId?: string;
    operation?: number;

    style?: any;

    IsBold?: boolean;
    IsRed?: boolean;
    IsGreen?: boolean;
    IsOrange?: boolean;
    IsPurple?: boolean;
    IsDarkYellow?: boolean;

    text: React.ReactNode;

    title?: string;

    className?: string;

    debounceMs?: number;
}

class SpanControl extends React.Component<ISpanProps, never> {
    public render(): JSX.Element {
        return (
            <span
                id={this.props.spanId}
                onClick={() => this.onClick()}
                style={this.style}
                title={this.props.title}
                className={this.props.className}
            >
                {this.props.text}
            </span>
        );
    }

    private get style(): React.CSSProperties {
        let style = { ...this.props.style };

        if (this.props.IsRed)
            style.color = "#ff0000";

        if (this.props.IsGreen)
            style.color = "#008000";

        if (this.props.IsOrange)
            style.color = "#ff5400";

        if (this.props.IsPurple)
            style.color = "#800080";

        if (this.props.IsDarkYellow)
            style.color = "#807000";

        if (this.props.IsBold)
            style.fontWeight = "bold";

        return style;
    }

    public onClick(): void {
        if (!this.props.operation)
            return;

        window.setTimeout(
            () => sessionStore.dispatch(this.props.operation, { id: this.props.id }),
            this.props.debounceMs ?? 5
        );
    }
}

export { SpanControl };
